import React from "react";
import {useHistory} from "react-router-dom";
import BlueButton from "../../Components/BlueButton";
import Horarios from "../../Components/Lista/Horarios";
import styled from "styled-components";

const Text=styled.h1`
margin:0;
justify-self:center;
font-size:24px;`;

const SubText=styled.h3`
text-align:center;
margin:0;
margin-top: 1rem;
justify-self:center;
font-size:20px;
font-weight:normal;

@media screen and (max-width:375px)
{
    font-size:17px;
}`;


const StatusActivada=({Logo})=>
{
    const History=useHistory();

    const Submit=()=>
    {
        History.push("/lista/cantidad")
    }

    return  <div style={{display:"grid",justifyContent:"center",alignContent:"center"}}>
        {Logo}
        <Text>Lista de espera</Text>
        <Text style={{maxWidth:"50%",fontSize:"20px",marginTop:"32px",textAlign:"center"}}><span role="img" aria-label="Emoji alerta" >⚠️</span>MUY IMPORTANTE:</Text> 
        <SubText style={{maxWidth:"80%",marginTop:"5px"}}>Estar presentes cuando tengan la mesa disponible sino tenemos que liberarla  <span role="img" aria-label="Emoji cerveza">🍻</span><span role="img" aria-label="Emoji manito">🤙</span></SubText> 
       <BlueButton onClick={Submit}>INGRESAR</BlueButton>
        <Horarios/>
    </div>
}

export default StatusActivada